import { IconButton, Tooltip } from "@mui/material";
import { FC } from "react";
import { styled } from "@mui/styles";
import useLocales from "../../hooks/useLocales";
import { useGetOneByIdQuery } from "../../features/api/Api";
import { isExists } from "../../utils";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

interface IListRefPreviewButton {
  id: string | number;
}

const PreviewButton = styled(IconButton)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  color: "#853EF8",
  "&:hover": {
    backgroundColor: "transparent",
    borderColor: "#0062cc",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

const ListRefPreviewButton: FC<IListRefPreviewButton> = ({ id }) => {
  const { translate } = useLocales();

  const { data: document }: any = useGetOneByIdQuery({
    resource: "fixity/document/file",
    id: id,
  });

  if (!isExists(document?.data?.filePath)) {
    return null;
  }
  return (
    <Tooltip title={translate("actions.preview")}>
      {document?.data?.filePath?.startsWith("https") ? (
        <a
          href={`${document.data.filePath}`}
          download
          rel="noopener noreferrer"
          target="_blank"
        >
          <PreviewButton>
            <RemoveRedEyeIcon color="primary" />
          </PreviewButton>
        </a>
      ) : (
        <a
          href={`http://${document.data.filePath}`}
          download
          rel="noopener noreferrer"
          target="_blank"
        >
          <PreviewButton>
            <RemoveRedEyeIcon color="primary" />
          </PreviewButton>
        </a>
      )}
    </Tooltip>
  );
};

export default ListRefPreviewButton;
